import type { MapSettingsDataResponse } from '~/map/map.repository';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import { mapSettingsBoundariesInitialState } from '~/store/mapSettings/boundaries/mapSettingsBoundaries.reducer';
import type { MapSettingsBoundariesState } from '~/store/mapSettings/boundaries/mapSettingsBoundaries.state';

const getBoundaryGroupOrder = (boundariesSettingResponse: MapSettingsDataResponse['boundaries']): ReadonlyArray<BoundaryGroupId> => {
  if (Array.isArray(boundariesSettingResponse.boundaryGroupOrder)) {
    return boundariesSettingResponse.boundaryGroupOrder;
  }

  return [];
};

export const mapSettingsBoundariesSerializer = {
  jsonToState: (json: MapSettingsDataResponse['boundaries']): MapSettingsBoundariesState => {
    return {
      ...mapSettingsBoundariesInitialState,
      ...json,
      boundaryGroupOrder: getBoundaryGroupOrder(json),
    };
  },
  stateToJson: (state: MapSettingsBoundariesState): MapSettingsDataResponse['boundaries'] => {
    return state;
  },
};
